const validateCardSeries = (text: string) => text.length === 3 && (/[A-Z]{3}/).test(text)
const validatePesel = (text: string) => (/^[0-9]\d{10}$|^[0-9]\d{10}$/).test(text)
const validateCardNumber = (text: string) => (/^[0-9]\d{5}$|^[0-9]\d{5}$/).test(text)
const validateCardSeriesAndNumber = (text: string) => (/[A-Z]{3}[0-9]{6}/).test(text)
const validateInputNumeric = (text: string) => (/^(-?\d+\.\d+)$|^(-?\d+)$/).test(text)

export const validators = {
    ID_CARD_SERIES: {
        validate: validateCardSeries,
        message: 'validator.id_card_series',
    },
    ID_CARD_SERIES_AND_NUMBER: {
        validate: validateCardSeriesAndNumber,
        message: 'validator.id_card_series_and_number',
    },
    PESEL: {
        validate: validatePesel,
        message: 'validator.pesel',
    },
    ID_CARD_NUMBER: {
        validate: validateCardNumber,
        message: 'validator.id_card_number',
    },
    NUMERIC: {
        validate: validateInputNumeric,
        message: 'validator.numeric',
    },
}

export default validators
